import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-selector-container slide" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "slide-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "slider-title" }, "Pick a Date")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "slide-content" }
const _hoisted_4 = { class: "selected-date flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Selected Date", -1 /* HOISTED */)
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode($setup["Calendar"], {
        modelValue: $setup.meetingDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.meetingDate) = $event)),
        popup: false,
        events: $props.events,
        invite: $props.invite,
        setMonth: $setup.setMonth,
        setYear: $setup.setYear,
        "onUpdate:TimesAvailable": $setup.getAvailability,
        "onUpdate:BufferedStart": $setup.setStart,
        "onUpdate:BufferedEnd": $setup.setEnd,
        "onUpdate:disabledDays": $setup.setDisabledDays,
        "onUpdate:blockedDays": $setup.setBlockedDays,
        "onUpdate:MeetingLength": $setup.setMeetingLength,
        "onUpdate:events": $setup.setEvents,
        "onUpdate:setMonth": $setup.selectedMonth,
        "onUpdate:setYear": $setup.selectedYear,
        "onUpdate:selectedDate": $setup.updateSelectedDate
      }, null, 8 /* PROPS */, ["modelValue", "events", "invite", "setMonth", "setYear", "onUpdate:BufferedStart", "onUpdate:BufferedEnd"]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.isDateSelected ? $setup.formatDate($setup.meetingDate) : 'Select a date above'), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "borderless back",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('previous')))
      }, "Back"),
      _createElementVNode("button", {
        class: "borderless",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.emit('progress'))),
        disabled: !$setup.isDateSelected
      }, "Next", 8 /* PROPS */, _hoisted_8)
    ])
  ]))
}